import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import IntroductionScreen from "./IntroductionScreen";
import ChallengesScreen from "./ChallengesScreen";
import CapabilitiesScreen from "./CapabilitiesScreen";
import Capabilities1AIScreen from "./Capabilities1AIScreen";
import Capabilities2BiometricsScreen from "./Capabilities2BiometricsScreen";
import Capabilities3ConversationalAiScreen from "./Capabilities3ConversationalAiScreen";
import Capabilities4VirtualAgentsScreen from "./Capabilities4VirtualAgentsScreen";
import Capabilities5IntelligentRoutingScreen from "./Capabilities5IntelligentRoutingScreen";
import Capabilities5_5AgentWellnessScreen from "./Capabilities5_5AgentWellness";
import Capabilities6RealTimeEmployeeGuidanceScreen from "./Capabilities6RealTimeEmployeeGuidanceScreen";
import Capabilities7OrchestratingWorkflowsScreen from "./Capabilities7OrchestratingWorkflowsScreen";
import Capabilities8ProactiveOutreachScreen from "./Capabilities8ProactiveOutreachScreen";
import Capabilities8_5AINoiseRemovalScreen from "./Capabilities8_5AINoiseRemovalScreen";
import Capabilities9CollaborationScreen from "./Capabilities9CollaborationScreen";
import Capabilities10InsightsAnalyticsScreen from "./Capabilities10InsightsAnalyticsScreen";
import PartnerEcosystemScreen from "./PartnerEcosystemScreen";
import ExploreScreen from "./ExploreScreen";
import AwardsScreen from "./AwardsScreen";
import ConclusionScreen from "./ConclusionScreen";

function Navigation() {
  return (
    <Routes>
      <Route path="/" element={<IntroductionScreen />} />
      <Route path="challenges" element={<ChallengesScreen />} />
      <Route path="capabilities" element={<CapabilitiesScreen />} />
      <Route path="capabilities-ai" element={<Capabilities1AIScreen />} />
      <Route
        path="capabilities-biometrics"
        element={<Capabilities2BiometricsScreen />}
      />
      <Route
        path="capabilities-conversational-ai"
        element={<Capabilities3ConversationalAiScreen />}
      />
      <Route
        path="capabilities-virtual-coworkers"
        element={<Capabilities4VirtualAgentsScreen />}
      />
      <Route
        path="capabilities-intelligent-routing"
        element={<Capabilities5IntelligentRoutingScreen />}
      />
      <Route
        path="capabilities-agent-wellness"
        element={<Capabilities5_5AgentWellnessScreen />}
      />
      <Route
        path="capabilities-real-time-employee-guidance"
        element={<Capabilities6RealTimeEmployeeGuidanceScreen />}
      />
      <Route
        path="capabilities-orchestrating-workflows"
        element={<Capabilities7OrchestratingWorkflowsScreen />}
      />
      <Route
        path="capabilities-outreach"
        element={<Capabilities8ProactiveOutreachScreen />}
      />
      <Route
        path="capabilities-ai-noise-removal"
        element={<Capabilities8_5AINoiseRemovalScreen />}
      />
      <Route
        path="capabilities-collaboration"
        element={<Capabilities9CollaborationScreen />}
      />
      <Route
        path="capabilities-insights-analytics"
        element={<Capabilities10InsightsAnalyticsScreen />}
      />
      <Route path="partner-ecosystem" element={<PartnerEcosystemScreen />} />
      <Route path="awards" element={<AwardsScreen />} />
      <Route path="conclusion" element={<ConclusionScreen />} />

      {/* 
/capabilities/
/capabilities/
/capabilities/
/capabilities/">Collaboration</Lin
/capabilities/

/partner-ecosystem
/explore
/awards
/conclusion
*/}
    </Routes>
  );
}

export default Navigation;
